import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { refreshToken } from '../init/initActions';

/**
 * Composant permettant de s'authentifier via le magic link
 */
const MagicLink = ({ match, dispatchRefreshToken }) => {
  useEffect(() => {
    dispatchRefreshToken({
      token: match.params.token,
      tokenFormat: 'jwt'
    });
  }, [dispatchRefreshToken, match.params.token]);
  return <div>Redirection en cours ...</div>;
};

const mapDispatchToProps = dispatch => ({
  dispatchRefreshToken: token => dispatch(refreshToken(token))
});

MagicLink.propTypes = {
  match: PropTypes.object.isRequired,
  dispatchRefreshToken: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(MagicLink);
